var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccesDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2260_2207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.59375 14.375H3.15625C3.75938 14.375 4.25 13.8844 4.25 13.2812V6.09375C4.25 5.49063 3.75938 5 3.15625 5H1.59375C0.990625 5 0.5 5.49063 0.5 6.09375V13.2812C0.5 13.8844 0.990625 14.375 1.59375 14.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48813 0.46875C7.86313 0.46875 7.55063 0.78125 7.55063 2.34375C7.55063 3.82875 6.1125 5.02375 5.1875 5.63937V13.3819C6.18813 13.845 8.19125 14.5312 11.3006 14.5312H12.3006C13.5194 14.5312 14.5569 13.6562 14.7631 12.4563L15.4631 8.39375C15.7256 6.8625 14.5506 5.46875 13.0006 5.46875H10.0506C10.0506 5.46875 10.5194 4.53125 10.5194 2.96875C10.5194 1.09375 9.11313 0.46875 8.48813 0.46875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2260_2207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccesDone);
export default __webpack_public_path__ + "static/media/succes-done.d6126453343cc3d858cf35f3bae76006.svg";
export { ForwardRef as ReactComponent };